import React, { isValidElement, ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@gerdau/hefesto';
import { ContentComponentProps } from '../../../utils/pageBuilder/types';

const isExternalHref = (href: string) => /^(https?:)?\/\//i.test(href);

export function PageBuilderButtons({
  children,
  'data-pb-style': styleId
}: ContentComponentProps) {
  return (
    <div className="buttons" data-pb-style={styleId as string | undefined}>
      {children}
    </div>
  );
}

export function PageBuilderButtonItem({
  children,
  'data-pb-style': styleId
}: ContentComponentProps) {
  const history = useHistory();

  const childArray = React.Children.toArray(children);
  const linkEl = childArray.find((c): c is ReactElement => isValidElement(c));

  if (!linkEl) return null;

  const href = linkEl.props.href as string | undefined;
  const label = linkEl.props.children;

  const handleClick = () => {
    if (!href) return;
    if (isExternalHref(href)) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else {
      history.push(href.startsWith('/') ? href : `/${href}`);
    }
  };

  return (
    <span data-pb-style={styleId as string | undefined}>
      <Button name={`cms-btn-${href ?? 'link'}`} onClick={handleClick}>
        {label}
      </Button>
    </span>
  );
}
